
import '@jaf/jaf-react-core/resources/index.css'
import '@jaf/jaf-react-icons/index.css'



import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.min.css'

import './index.css'

import React from 'react'
import ReactDOM from "react-dom/client"

import { itLocale } from '@jaf/jaf-react-core'
// ...


import './index.css'
import * as serviceWorker from './serviceWorker'

import Wrapper from './Wrapper/Wrapper'
import { addLocale } from 'primereact/api'


const renderApp = () => {

  addLocale('it', itLocale) // 
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <Wrapper />
    </React.StrictMode>
  );


}

renderApp();

serviceWorker.unregister()
